import { render, staticRenderFns } from "./ResellerProductSelector.vue?vue&type=template&id=2a0bd3ec"
import script from "./ResellerProductSelector.vue?vue&type=script&lang=js"
export * from "./ResellerProductSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports